export default function tradeAccountNavContent() {
    return import(/* webpackChunkName: "tradeAccountNavContent" */
    './TradeAccountNavContent').then(mod => {
        return mod.default;
    });
}
